// 定义是否折叠小仓库（选择式Api写法）
import { defineStore } from "pinia";
import { PINIA_PREFIX } from "@/config";
// defineStore方法执行会返回一个函数，函数的作用就是让组件可以获取到仓库数据
const useTaskStore = defineStore("task", {
  // 开启数据持久化
  persist: {
    // enabled: true, // true 表示开启持久化保存，默认localStorage
    key: PINIA_PREFIX + "task", // 默认会以 store 的 id 作为 key
    storage: localStorage,
  },
  // 可以通过为属性指定选项来配置持久化方式persist
  // persist: {
  //     paths: ['isCollapse'],
  //     storage: sessionStorage
  // },
  // 存储数据state
  state: () => {
    return {
      taskId: "", // 任务ID
      taskName: "", // 任务名称
      taskTemplateId: "", // 任务模板ID
      subtaskId: "", // 子任务ID
      regionname: "", // 区划表
      townregiondt: "", // 乡镇区划表
      villageregiondt: "", // 村区划表
      taskxzqhdms: "", // 任务行政区
      subtaskWhereConfig: "", // 子任务配置的查询条件字段映射
      modulesIds: [], // 子任务id
      taskFormProcessConfig: {}, // 审批流程
      dataInportConfigList: [], // 数据导入配置
      formModuleFieldDescList: [], // 数据导入字段配置
      collectionTaskId: "", // 采集任务id
    };
  },
  // 该函数没有上下文数据，所以获取state中的变量需要使用this
  actions: {
    // Set taskId
    setTaskId(taskId: string) {
      this.taskId = taskId;
    },

    // Set taskName
    setTaskName(taskName: string) {
      this.taskName = taskName;
    },

    // Set taskTemplateId
    setTaskTemplateId(taskTemplateId: string) {
      this.taskTemplateId = taskTemplateId;
    },

    // Set subtaskId
    setSubtaskId(subtaskId: string) {
      this.subtaskId = subtaskId;
    },

    // 设置任务区划信息
    setTaskRegionData(taskInfo: { [x: string]: any }) {
      this.regionname = taskInfo.regionname;
      this.townregiondt = taskInfo.townregiondt;
      this.villageregiondt = taskInfo.villageregiondt;
      this.taskxzqhdms = taskInfo.taskxzqhdms;
    },

    // 设置
    setSubtaskWhereConfig(subtaskWhereConfig: string) {
      this.subtaskWhereConfig = subtaskWhereConfig;
    },

    // 设置任务数据
    setTaskData(taskData: any) {
      const { modulesIds, taskFormProcessConfig, dataInportConfigList, formModuleFieldDescList } = taskData;
      this.modulesIds = modulesIds;
      this.taskFormProcessConfig = taskFormProcessConfig;
      this.dataInportConfigList = dataInportConfigList;
      this.formModuleFieldDescList = formModuleFieldDescList;
    },

    // 设置采集任务id
    setCollectionTaskId(collectionTaskId: string) {
      this.collectionTaskId = collectionTaskId;
    },
  },
  // 计算属性
  getters: {},
});

// 对外暴露方法
export default useTaskStore;
